import { ArrowDownIcon } from '@heroicons/react/20/solid';

import { ShiftRibbon } from '../api/types';

// Status pill at the top of a shift card. Per Figma Dev Mode these are plain
// 12px SemiBold badges with no icon — except the downward Dependability
// indicator, which carries an arrow-down glyph and a red outline.
//
// Every label is wrapped in .dashv2-ribbon-label so it can ellipsize (and, on a
// very narrow card, drop to the glyph alone) instead of pushing the row past the
// card edge where it would be clipped. See .dashv2-card-toprow in the CSS.

export const DependabilityRibbon = () => (
  <span className="dashv2-ribbon type-dependability">
    <ArrowDownIcon />
    <span className="dashv2-ribbon-label">Dependability</span>
  </span>
);

const formatHours = (hours?: number | null): string => {
  if (hours == null) return 'Starts soon';
  const rounded = Math.round(hours * 10) / 10;
  return `Starts in ${rounded}h`;
};

const RIBBON_LABELS = {
  needs_approval: 'Needs approval',
  in_progress: 'In progress',
} as const;

type Props = { ribbon: ShiftRibbon };

const StatusRibbon = ({ ribbon }: Props) => {
  switch (ribbon.type) {
    case 'needs_approval':
    case 'in_progress':
      return (
        <span className={`dashv2-ribbon type-${ribbon.type}`}>
          <span className="dashv2-ribbon-label">
            {RIBBON_LABELS[ribbon.type]}
          </span>
        </span>
      );
    case 'starts_in':
      return (
        <span className="dashv2-ribbon type-starts_in">
          <span className="dashv2-ribbon-label">
            {formatHours(ribbon.hours)}
          </span>
        </span>
      );
    default:
      return null;
  }
};

export default StatusRibbon;
